import '@Global/user';
import '@Global/modal';
import '@Global/colorpicker';
import '@Global/loading-toast';
import '@Global/email-wizard';
import '@Global/auto-branding';
import '@Global/email-campaign-ai-content';
import '@Global/admin-save-section-template-panel';
import '@Global/color-palette-panel';
import '@Global/brand-kit-palette-editor';
import '@Global/email-maker-block-manager';
import '@Global/toast';

import React from 'react';
import {ModalContainer} from '@Components/modal-container';
import ModalContainerDeprecated from '@Components/modal-container-deprecated';
import {LoadingToast} from '@Components/loading-toast';
import {MessageGrowl} from '@Components/message-growl';
import App from '@Components/app';
import '@/email-maker/main';
import {createRoot} from 'react-dom/client';

const a = document.createElement('div');
a.setAttribute('id', 'pmw-app');
document.body.appendChild(a);

const root = createRoot(document.getElementById('pmw-app')!);
root.render(
  <App>
    <ModalContainerDeprecated />
    <ModalContainer />
    <LoadingToast />
    <MessageGrowl />
  </App>
);
